import React, { Component } from "react";
import {
  Container,
  Modal,
  Button,
} from "react-bootstrap";
import { withApollo } from "react-apollo";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import SnackbarMessage from "../../../../components/snackBar/snackBar";
import CardLessDataTableWithSearch from "../../datatables/CardLessDataTableWithSearch";

const GET_NEXT_LEVEL_TOTAL_USERS = gql`
  query getNextLevelTotalUsers($instituteId: Int!, $branchId: Int!, $employeeId: Int) {
    getNextLevelTotalUsers(institute_id: $instituteId, branch_id: $branchId, employee_id: $employeeId) {
      total_users_details {
        employee_id
        employee_name
        emp_email
        employee_type
        branch_name
        department_name
        lead_details {
          id
          lead_status_type
          details {
            id
            student_name
            student_mobile
            source_name
            branch_name
            inserted_at
          }
        }
      }
      status_details {
        status_id
        status_name
        status_count
      }
    }
  }
`;

const THEME = {
  primary: "#3b82f6",
  success: "#10b981",
  danger: "#ef4444",
  warning: "#f59e0b",
  text: "#0f172a",
  textMuted: "#64748b",
  border: "#e2e8f0",
  bgCard: "#ffffff",
  bgLight: "#f8fafc",
};

class MyTeamTask extends Component {
  constructor(props) {
    super(props);
    this.state = {
      teamData: {
        total_users_details: [],
        status_details: [],
      },
      status: "idle",
      error: null,
      snackbar: { open: false, message: "", severity: "success" },
      modalState: {
        open: false,
        selectedLeads: [],
        statusTitle: "",
        employeeName: "",
      },
    };
  }

  componentDidMount() {
    this.fetchTeamTasks();
  }

  fetchTeamTasks = async () => {
    const { client } = this.props;
    const institutionId = Cookies.get("institutionid");
    const branchId = Cookies.get("branch_id");

    if (!institutionId || !branchId) {
      console.warn("Missing institutionid or branch_id cookies", { institutionId, branchId });
      this.setState({ status: "succeeded" });
      return;
    }

    const instId = parseInt(institutionId);
    const brId = parseInt(branchId);

    this.setState({ status: "loading" });

    try {
      const empId = Cookies.get("id") || Cookies.get("employee_id");
      const response = await client.query({
        query: GET_NEXT_LEVEL_TOTAL_USERS,
        variables: { 
          instituteId: instId, 
          branchId: brId,
          employeeId: empId ? parseInt(empId) : null
        },
        fetchPolicy: "network-only",
      });

      console.log("Team Tasks Response:", response.data);

      this.setState({
        teamData: response.data.getNextLevelTotalUsers || { total_users_details: [], status_details: [] },
        status: "succeeded",
      });
    } catch (error) {
      console.error("Error fetching team tasks:", error);
      this.setState({
        status: "failed",
        snackbar: { open: true, message: "Failed to load team tasks: " + error.message, severity: "error" },
      });
    }
  };

  handleOpenLeads = (leads, status, empName) => {
    this.setState({
      modalState: {
        open: true,
        selectedLeads: leads || [],
        statusTitle: status,
        employeeName: empName,
      },
    });
  };

  handleCloseModal = () => {
    this.setState((prev) => ({
      modalState: { ...prev.modalState, open: false },
    }));
  };

  getTableData = () => {
    const { total_users_details = [], status_details = [] } = this.state.teamData;
    return total_users_details.map(user => {
      const row = {
        id: user.employee_id,
        employee_name: user.employee_name,
        emp_email: user.emp_email,
        employee_type: user.employee_type,
      };
      status_details.forEach(stat => {
        const leadGroup = user.lead_details.find(ld => ld.id === stat.status_id);
        row[`count_${stat.status_id}`] = leadGroup ? leadGroup.details.length : 0;
        row[`leads_${stat.status_id}`] = leadGroup ? leadGroup.details : [];
      });
      return row;
    });
  };

  getTableColumns = () => {
    const { status_details = [] } = this.state.teamData;
    return [
      {
        dataField: "employee_name", text: "Employee",
        formatter: (cell, row) => (
          <div>
            <div style={{ fontWeight: 700 }}>{cell}</div>
            <div style={{ fontSize: "12px", color: THEME.textMuted }}>{row.emp_email}</div>
          </div>
        ),
      },
      { dataField: "employee_type", text: "Type" },
      ...status_details.map(stat => ({
        dataField: `count_${stat.status_id}`,
        text: stat.status_name,
        formatter: (cell, row) => cell > 0 ? (
          <button
            className="btn btn-link p-0 fw-bold text-decoration-none"
            style={{ color: THEME.primary }}
            onClick={() => this.handleOpenLeads(row[`leads_${stat.status_id}`], stat.status_name, row.employee_name)}
          >
            {cell}
          </button>
        ) : <span className="text-muted opacity-50">-</span>,
      })),
    ];
  };

  modalColumns = [
    { dataField: "id", text: "SNO", formatter: (cell, row, rowIndex) => rowIndex + 1 },
    { dataField: "student_name", text: "Student Name" },
    { dataField: "student_mobile", text: "Mobile" },
    {
      dataField: "source_name", text: "Source",
      formatter: (cell) => <span className="badge bg-light text-dark border">{cell}</span>,
    },
    { dataField: "branch_name", text: "Branch" },
    {
      dataField: "inserted_at", text: "Date",
      formatter: (cell) => new Date(cell).toLocaleDateString(),
    },
  ];

  render() {
    const { teamData = {}, status, modalState, snackbar } = this.state;
    const { total_users_details = [], status_details = [] } = teamData;

    const COLOR_MAP = {
      "open": "#3b82f6",
      "inprocess": "#8b5cf6",
      "admitted": "#10b981",
      "rejected": "#ef4444",
      "follow up": "#f59e0b",
      "total leads": "#ff9500"
    };

    return (
      <Container fluid className="px-0">
        {/* Status Pills */}
        <div className="d-flex gap-3 mb-4 mt-3 flex-wrap overflow-auto pb-2">
          {status_details.map((stat) => {
            const color = COLOR_MAP[stat.status_name.toLowerCase()] || "#64748b";
            return (
              <div
                key={stat.status_id}
                className="d-flex align-items-center gap-2 px-3 py-2 rounded-pill border-2 bg-white"
                style={{
                  border: `2px solid ${color}`,
                  color: color,
                  fontSize: "13px",
                  fontWeight: 600,
                  transition: "all 0.3s ease",
                  cursor: "default"
                }}
              >
                <span>{stat.status_name}</span>
                <span className="rounded-circle d-flex align-items-center justify-content-center fw-bold" style={{
                  minWidth: "28px",
                  height: "28px",
                  backgroundColor: `${color}20`,
                }}>
                  {stat.status_count}
                </span>
              </div>
            );
          })}
        </div>

        {/* Team Productivity Table */}
        {status === "loading" ? (
          <div className="p-5 text-center text-muted">Loading team data...</div>
        ) : (
          <CardLessDataTableWithSearch
            parentData={this.getTableData()}
            particlecolumns={this.getTableColumns()}
            defaultSorted={[{ dataField: "employee_name", order: "asc" }]}
            name="team"
          />
        )}

        {/* Lead Details Modal */}
        <Modal show={modalState.open} onHide={this.handleCloseModal} size="xl" centered>
          <Modal.Header closeButton className="bg-light">
            <Modal.Title>
              <span className="text-primary">{modalState.statusTitle}</span> Leads - {modalState.employeeName}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "16px" }}>
            <CardLessDataTableWithSearch
              parentData={modalState.selectedLeads}
              particlecolumns={this.modalColumns}
              defaultSorted={[{ dataField: "student_name", order: "asc" }]}
              name="modal-leads"
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseModal}>Close</Button>
          </Modal.Footer>
        </Modal>

        <SnackbarMessage
          open={snackbar.open}
          message={snackbar.message}
          severity={snackbar.severity}
          onClose={() => this.setState({ snackbar: { open: false, message: "", severity: "success" } })}
        />
      </Container>
    );
  }
}

export default withApollo(MyTeamTask);
